/**
 * Ending a session, and nothing else.
 *
 * Its own file rather than a place in `service.ts`, which is where it belongs
 * by subject. The header runs on every page including the policy ones, and
 * `service.ts` reaches the renderer through the shelf, so taking two lines from
 * there put sixteen kilobytes of sprite renderer onto every page on the site to
 * save a repeated `fetch`. Measured: `chrome.js` went from 5.6k to 21.4k.
 *
 * The duplication was worth removing and the cost of removing it that way was
 * not. Nothing here imports anything.
 */
export async function signOut(): Promise<void> {
	await fetch("/api/signout", { method: "POST" });
	location.href = "/";
}
